module.exports = __webpack_public_path__ + "static/media/arrow_button_top.6af0e485.svg";